import React, { memo, useEffect, useState } from 'react';
import { createTreeData } from '../../helpers/create-tree-json';
import TreeMultiSelectDropdown from '../../sharedcomponents/tree-multi-select-dropdown/tree-multi-select-dropdown';
import { Endpoints, GenericName } from './../../constants';
import { getDbConfigData } from './../../helpers/component-helper-methods';
import { useDispatch } from 'react-redux';

const ProductDistributorsDropdown = memo(
  ({
    DataSet,
    Type,
    callBackDistributors,
    disabled = false,
    enableSelectAll = true,
  }) => {
    const [distributorsResult, setDistributorsResult] = useState([]);
    const [treeDistributorsData, setTreeDistributorsData] = useState();
    const [dstCount, setDstCount] = useState(0);
    const CI_ParentKeys = ['distributorPlatformDisplayName'];
    const CP_ParentKeys = [
      'distributorDisplayName',
      'distributorPlatformDisplayName',
    ];
    const dispatch = useDispatch();
    useEffect(() => {
      const reduceCallback = setTimeout(async () => {
        getDistributorsDataSet();
      }, 300);
      return () => clearTimeout(reduceCallback);
    }, [DataSet]);

    const getDistributorsDataSet = async () => {
      try {
        if (DataSet) {
          // get the recommended Platform from the DB config
          let storeDBConfig = await getDbConfigData(dispatch);
          const recommendedDistPltf =
            storeDBConfig?.recommendedPlatforms?.map(
              (item) => item.distributorId,
            ) ?? [];

          let finalDistributorsResult = DataSet?.results
            ?.filter(
              (el) =>
                el.platformCategories &&
                el.platformCategories !== '' &&
                el.distributorDisplayName &&
                el.distributorDisplayName !== '' &&
                el.distributorPlatformDisplayName &&
                el.distributorPlatformDisplayName !== '' &&
                el.deliveryType &&
                el.deliveryType !== '',
            )
            .map((el, i) => {
              const platformSuffix =
                el.deliveryType?.toLowerCase() !== 'web'
                  ? ` (${el.deliveryType})`
                  : '';
              return {
                id: el.distributorId ?? i,
                checked: Type === 'ProductEntitlements',
                distributorLabel:
                  el.distributorDisplayName +
                  ' : ' +
                  el.distributorPlatformDisplayName +
                  platformSuffix,
                ...el,
                distributorPlatformDisplayName:
                  el.distributorPlatformDisplayName,
                isRecommended: recommendedDistPltf.some(
                  (platform) => platform === el.distributorId,
                ),
              };
            });
          const deliveryTypeById = new Map(
            finalDistributorsResult.map((item) => [
              String(item.id),
              item.deliveryType,
            ]),
          );
          const getPlatformLabel = (node) => {
            const baseLabel = node.actualLabel ?? node.label;
            const deliveryType = deliveryTypeById.get(String(node.id));
            return deliveryType && deliveryType.toLowerCase() !== 'web'
              ? `${baseLabel} (${deliveryType})`
              : baseLabel;
          };

          const indicatedDistPltf = [
            ...new Set(
              finalDistributorsResult
                .filter((el) => el?.indicatePlatform)
                .map((el) => el.distributorId),
            ),
          ];

          let CP_Distributor = finalDistributorsResult
            .filter(
              (el) => el?.platformCategories === GenericName.channelPartners,
            )
            .sort((a, b) => {
              // First, sort by distributorDisplayName
              const parentKey0Compare = a[CP_ParentKeys[0]].localeCompare(
                b[CP_ParentKeys[0]],
              );
              if (parentKey0Compare !== 0) return parentKey0Compare;

              // Then, sort by isRecommended
              if (a.isRecommended && !b.isRecommended) return -1;
              if (!a.isRecommended && b.isRecommended) return 1;

              // Then, sort by indicatePlatform
              if (a.indicatePlatform && !b.indicatePlatform) return -1;
              if (!a.indicatePlatform && b.indicatePlatform) return 1;

              // Finally, sort by distributorPlatformDisplayName
              return a[CP_ParentKeys[1]].localeCompare(b[CP_ParentKeys[1]]);
            });

          let CI_Distributor = finalDistributorsResult
            .filter(
              (el) => el?.platformCategories === GenericName.spGlobalEnergy,
            )
            .sort((a, b) => {
              // First, sort by isRecommended
              if (a.isRecommended && !b.isRecommended) return -1;
              if (!a.isRecommended && b.isRecommended) return 1;

              // Then, sort by indicatePlatform
              if (a.indicatePlatform && !b.indicatePlatform) return -1;
              if (!a.indicatePlatform && b.indicatePlatform) return 1;

              // Finally, sort by distributorPlatformDisplayName
              return a[CI_ParentKeys[0]].localeCompare(b[CI_ParentKeys[0]]);
            });

          let CP_TreeData = await createTreeData(
            CP_Distributor,
            CP_ParentKeys,
            'CP',
          );
          let CI_TreeData = await createTreeData(
            CI_Distributor,
            CI_ParentKeys,
            'CI',
          );

          let treeData = [];
          if (CI_TreeData?.length > 0) {
            // Add recommended tag to the recommended delivery platforms
            CI_TreeData.map((el) => {
              el.actualLabel = el.label;
              const platformLabel = getPlatformLabel(el);
              const isIndicated = indicatedDistPltf.some(
                (platform) => platform == el.id,
              );
              const isRecommended = recommendedDistPltf.some(
                (platform) => platform == el.id,
              );
              el.label = (
                <div>
                  {platformLabel}
                  {isIndicated && (
                    <span
                      className="ml-1"
                      title="Currently subscribed by other users"
                    >
                      🟢
                    </span>
                  )}
                  {isRecommended && (
                    <span className="dd-tag ml-1">Recommended</span>
                  )}
                </div>
              );
              return el;
            });

            treeData.push({
              label: GenericName.spGlobalEnergy,
              value: 'CI',
              children: CI_TreeData,
            });
          }

          if (CP_TreeData?.length > 0) {
            // Add recommended tag to the recommended delivery platforms
            CP_TreeData.map((el) => {
              if (el.children) {
                el.children.map((child) => {
                  child.actualLabel = child.label;
                  const childPlatformLabel = getPlatformLabel(child);
                  const isIndicated = indicatedDistPltf.some(
                    (platform) => platform == child.id,
                  );
                  const isRecommended = recommendedDistPltf.some(
                    (platform) => platform == child.id,
                  );
                  child.label = (
                    <div>
                      {childPlatformLabel}
                      {isIndicated && (
                        <span
                          style={{ marginLeft: 4 }}
                          title="Currently subscribed by other users"
                        >
                          🟢
                        </span>
                      )}
                      {isRecommended && (
                        <span className="dd-tag ml-1">Recommended</span>
                      )}
                    </div>
                  );
                  return child;
                });
              }

              // bubble indicator to parent
              el.actualLabel = el.label;
              const hasChildIndicator = el.children?.some((child) =>
                indicatedDistPltf.some((p) => p == child.id),
              );
              el.label = (
                <div>
                  {el.label}
                  {hasChildIndicator && (
                    <span
                      className="ml-1"
                      title="Currently subscribed by other users"
                    >
                      🟢
                    </span>
                  )}
                </div>
              );

              return el;
            });

            // sort parents with indicators first, then alphabetically
            CP_TreeData.sort((a, b) => {
              const aHas = a.children?.some((child) =>
                indicatedDistPltf.some((p) => p == child.id),
              );
              const bHas = b.children?.some((child) =>
                indicatedDistPltf.some((p) => p == child.id),
              );
              if (aHas && !bHas) return -1;
              if (!aHas && bHas) return 1;
              return a.actualLabel.localeCompare(b.actualLabel);
            });

            treeData.push({
              label: GenericName.channelPartners,
              value: 'CP',
              children: CP_TreeData,
            });
          }

          setTreeDistributorsData(
            finalDistributorsResult?.length > 0 ? treeData : [],
          );
          setDistributorsResult(finalDistributorsResult ?? []);
        }
      } catch (err) {
        setTreeDistributorsData([]);
      }
    };

    const handleSelection = (selectedTreeData) => {
      let uniqueArr = [];
      let updatedState = [];
      distributorsResult?.forEach((obj) => {
        if (
          selectedTreeData?.some((el) => String(el) === String(obj.id)) &&
          !uniqueArr.some((el) => el === obj.id)
        ) {
          uniqueArr.push(obj.id);
          updatedState.push({
            ...obj,
            checked: true,
            distributorDisplayName:
              obj.distributorDisplayName +
              ':' +
              obj.distributorPlatformDisplayName +
              ':' +
              obj.deliveryType,
          });
        }
      });

      setDstCount(selectedTreeData?.length);
      // return the selected distributors to parent component
      callBackDistributors(updatedState);
    };

    return (
      <TreeMultiSelectDropdown
        ddOptions={treeDistributorsData}
        getSelectedTreeData={handleSelection}
        enableSearch
        enableSelectAll={enableSelectAll}
        ddPlaceHolder={
          <>
            Delivery Platform
            <span className={dstCount === 0 ? 'd-none' : 'd-inline'}>
              ({dstCount})
            </span>
          </>
        }
        disabled={disabled}
      />
    );
  },
  (op, np) => op?.DataSet === np?.DataSet,
);

export default ProductDistributorsDropdown;
